<div id="parent-div">
    <emap-map-image></emap-map-image>
    <emap-toolbox></emap-toolbox>
    <emap-global-panel></emap-global-panel>
    <emap-filter-panel></emap-filter-panel>
    <emap-keyboard></emap-keyboard>
    <emap-chart-display></emap-chart-display>
</div>